import Page from "@/components/layout/Page";

export default function EducationMarketplace() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6">Education Marketplace</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Browse our curated selection of sensory products designed specifically for educational environments.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our Education Kits are designed to support schools of all sizes, from small classroom sets to whole-school provisions. Each kit is carefully curated to provide the right mix of sensory tools for different educational needs and settings.
            </p>
            
            <p className="text-lg leading-relaxed">
              Whether you're equipping a SEND school, adding sensory support to mainstream classrooms, or creating calm spaces and sensory rooms, our education marketplace offers bulk ordering options and specialist advice to help you choose the right products.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our products support focus, self-regulation, and wellbeing in the classroom. They're ideal for children with ADHD, autism, anxiety, and other sensory processing needs, helping create inclusive learning environments where every child can thrive.
            </p>
            
            <p className="text-lg leading-relaxed">
              Contact us to discuss your school's specific requirements and we can help design a sensory toolkit that meets your educational goals and budget.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
